import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={40} height={40} rx={20} fill={theme["#B4E3E1"]} />
            <path
                d="M16.984 17.374c.58 1.208 1.37 2.34 2.371 3.341a12.17 12.17 0 003.342 2.372c.104.05.156.075.222.094.233.069.52.02.718-.122.056-.04.103-.088.199-.183.29-.291.437-.437.583-.532a1.667 1.667 0 011.817 0c.146.095.292.24.584.532l.162.162c.443.443.664.665.785.903.239.473.239 1.031 0 1.504-.12.238-.342.46-.785.902l-.131.132c-.442.441-.662.662-.962.83-.333.187-.85.322-1.232.32-.344 0-.58-.067-1.05-.2a15.866 15.866 0 01-6.903-4.062 15.866 15.866 0 01-4.061-6.903c-.134-.47-.2-.706-.202-1.05a2.814 2.814 0 01.32-1.232c.17-.3.39-.52.831-.962l.132-.131c.443-.443.664-.664.902-.785a1.667 1.667 0 011.504 0c.238.12.46.342.902.785l.163.162c.291.292.437.437.532.584.36.552.36 1.264 0 1.817-.095.146-.24.292-.532.583-.095.096-.143.143-.183.199a.872.872 0 00-.122.718c.019.066.044.118.094.222z"
                stroke={theme["#0D968F"]}
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
  
  export default SvgComponent